import React from 'react';
import classes from './Input.css';

const input = (props) => {
    // console.log('[PROPS]',props)
    const inputClasses = [classes.InputElement];

    let validationError = null;

    if(props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
        validationError = <p className={classes.ErrorMessage}>Please enter a valid {props.label}</p>
    }

    let inputElement = null;
    switch(props.elementType) {
        case('input'):
            inputElement = (
                <input className={inputClasses.join(' ')}
                       {...props.elementConfig}
                       value={props.value}
                       onChange={props.changed}
                />
            );
            break;
        case('textarea'):
            inputElement = <textarea className={inputClasses.join(' ')}
                                     {...props.elementConfig}
                                     value={props.value}
                                     onChange={props.changed}
            />;
            break;
        case('select'):
            inputElement = (
                <select className={inputClasses.join(' ')}
                        value={props.value}
                        onChange={props.changed}
                >
                    {props.elementConfig.options.map(option => (
                        <option value={option.value} key={option.value}>{option.displayValue}</option>
                    ))}

                </select>
            );
            break;

        default:
            inputElement = <input className={inputClasses.join(' ')}
                                  {...props.elementConfig}
                                  value={props.value}
                                  onChange={props.changed}
            />;
    }
    return(
        <div className={classes.Input}>
            {inputElement}
            {validationError}
        </div>
    )

};

export default input;


// WEBPACK FOOTER //
// ./src/Components/UI/Forms/Input/Input.js